<div class="container">
    <div class="row header py-2">
        <div class="col cursor text-center">
            <h6>Referral Details</h6>
        </div>
    </div>
</div>
<div style="padding-top: 40px !important;">
    <div class="row form-group">
        <div class="col">
            <div class="row">
                <div class="col table-responsive">
                    <table class="table">
                        <thead class="thead-light">
                            <tr>
                                <th>Merchant</th>
                                <th>Referred</th>
                                <th>Earned</th>
                                <th>Redeemed</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="referredList.length === 0" class="border-bottom">
                                <td colspan="4">No referrals found</td>
                            </tr>
                            <tr *ngFor="let rowdata of referredList">
                                <td>{{rowdata.merchantname}}</td>
                                <td>
                                    <div>{{rowdata.referredtoName}}</div>
                                    <small>({{rowdata.referredtoContact}})</small>
                                </td>
                                <td>{{rowdata.earnedDate}}</td>
                                <td>{{rowdata.redeemedDate}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<app-ecom-footer class="footer"></app-ecom-footer>
<app-loading-component></app-loading-component>